import {
    GenericCandidateLite,
    PresentCandidateValues,
} from '../api/role/models/CandidateDto'
import { TriStateToggleValue } from '../components/TriStateToggle'

export function getPresentValueForCandidate(candidate: {
    present?: PresentCandidateValues
}): TriStateToggleValue {
    switch (candidate.present) {
        case PresentCandidateValues.YES:
            return 'yes'
        case PresentCandidateValues.NO:
            return 'no'
        default:
            return 'not_selected'
    }
}

export function toPresentCandidateValue(
    value: TriStateToggleValue,
): PresentCandidateValues | undefined {
    switch (value) {
        case 'yes':
            return PresentCandidateValues.YES
        case 'no':
            return PresentCandidateValues.NO
        case 'not_selected':
        default:
            return undefined
    }
}

type CandidatePresentLike = Pick<
    GenericCandidateLite,
    'candidatePersonId' | 'present'
>

export const buildCandidatePresentMap = (
    storeCandidates: CandidatePresentLike[],
    ephemeralCandidates: CandidatePresentLike[],
) => {
    const candidatePresentById = new Map<
        string,
        PresentCandidateValues | undefined
    >()

    for (const candidate of storeCandidates) {
        candidatePresentById.set(candidate.candidatePersonId, candidate.present)
    }

    for (const candidate of ephemeralCandidates) {
        if (!candidatePresentById.has(candidate.candidatePersonId)) {
            candidatePresentById.set(
                candidate.candidatePersonId,
                candidate.present,
            )
        }
    }

    return candidatePresentById
}

export const getCandidatesNeedingSave = <T extends CandidatePresentLike>(
    candidates: T[],
    candidatePresentById: Map<string, PresentCandidateValues | undefined>,
) => {
    return candidates.filter((candidate) => {
        const hasLocalState = candidatePresentById.has(
            candidate.candidatePersonId,
        )
        const latestPresent = hasLocalState
            ? candidatePresentById.get(candidate.candidatePersonId)
            : candidate.present

        return (
            latestPresent !== PresentCandidateValues.YES &&
            latestPresent !== PresentCandidateValues.NO
        )
    })
}
